<template>
  <div
    :class="`w-full flex justify-center bg-themeComponentBg-light font-rubik ${
      aboutUs ? 'pt-12 1240-bp:pt-28 1240-bp:pb-16' : 'get-in-touch-outer-container'
    }`"
  >
    <div :class="`w-full ${aboutUs ? 'max-w-1024 mx-5' : 'max-w-1440 mx-5'}`">
      <div class="w-full flex flex-col gap-8 1240-bp:flex-row 1240-bp:gap-16">
        <find-inventory class="w-full 1240-bp:w-1/2" />

        <div class="w-full 1240-bp:w-1/2">
          <article
            v-if="lead"
            class="message is-medium is-primary contact-us-article-container"
          >
            <div class="message-header" style="background-color: #3565FC;">
              <p>Thanks for the inquiry, {{ lead.firstName }}.</p>
            </div>
            <div class="message-body" style="background-color: #FFFFFF;">
              <p>
                One of our representatives will be in contact shortly.
                If you need immediate service, please call us at {{ phoneNumber }}.
              </p>
            </div>
          </article>

          <p v-else-if="error">
            We are sorry, there was a problem with your request. Error:
            {{ error }}
          </p>

          <contact-us-form
            v-else
            @success="handleSuccess"
            @error="handleError"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FindInventory from './helpers/find-inventory.vue'
import ContactUsForm from './helpers/contact-us-form.vue'

export default {
  components: {
    FindInventory,
    ContactUsForm
  },
  props: {
    aboutUs: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      lead: null,
      error: null
    }
  },
  computed: mapState('shared', ['phoneNumber']),
  methods: {
    handleSuccess (lead) {
      this.lead = lead
    },
    handleError (error) {
      this.error = error
    }
  }
}
</script>

<style scoped>
.get-in-touch-outer-container {
  padding-top: 112px;
}

.contact-us-article-container {
  margin-bottom: 24px;
}

@media (max-width: 1240px) {
  .get-in-touch-outer-container {
    padding-top: 20px;
  }
}
</style>
